export function setHtmlClass(className) {
  const doc = document;
  doc.documentElement.setAttribute("class", className);
  doc.body.className = className;
}
export function getHost() {
  if (!isBrowser()) return;
  const currentHost = window.location.host;
  const hostConfig = {
    default: "http://api-gospeedtest-test.onethingpcs.com",
    "speedtest-test.onethingpcs.com":
      "http://api-gospeedtest-test.onethingpcs.com",
    "speedtest.onethingpcs.com": "https://api-gospeedtest.onethingpcs.com",
  };
  const host = hostConfig[currentHost] || hostConfig.default;
  return host;
}

export function isBrowser() {
  return (
    typeof window !== "undefined" &&
    typeof window.document !== "undefined" &&
    typeof window.document.createElement !== "undefined"
  );
}

export function isPC() {
  if (!isBrowser()) return;
  const ua = window.navigator.userAgent.toLowerCase();
  const isPC =
    !/Android|iPhone|SymbianOS|Windows\s+Phone|iPad|iPod|XiaoMi\/MiuiBrowser/i.test(
      ua
    );
  return isPC;
}

export function browser(type) {
  const u = navigator.userAgent.toLowerCase();
  const { screen } = window;
  const versions = {
    // 移动终端浏览器版本信息
    h5: /Android|webOS|iPhone|iPad|BlackBerry/i.test(u),
    trident: u.indexOf("trident") > -1, // IE内核
    presto: u.indexOf("presto") > -1, // opera内核
    webKit: u.indexOf("appleWebKit") > -1, // 苹果、谷歌内核
    gecko: u.indexOf("gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
    mobile: !!u.match(/appleWebKit.*mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), // ios终端
    android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, // android终端或者uc浏览器
    iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("ipad") > -1, // 是否iPad
    iPod: u.indexOf("ipod") > -1,
    webApp: u.indexOf("safari") === -1, // 是否web应该程序，没有头部与底部
    wx: u.indexOf("micromessenger") > -1,
    nokia: u.indexOf("nokia") > -1,
    pcwx: u.indexOf("windowswechat") > -1,
    pc: !/Android|iPhone|SymbianOS|Windows\s+Phone|iPad|iPod/i.test(u),
    // ie: u.indexOf('msie') > -1,
    ie:
      (u.indexOf("msie") > -1 ||
        u.indexOf("edge") > -1 ||
        u.indexOf("trident") > -1) &&
      u.indexOf("opera") === -1,
    x5: u.indexOf("mqqbrowser") > -1,
    weibo: u.indexOf("weibo") > -1 || u.indexOf("Weibo") > -1,
    iphoneX: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/) && screen.height >= 812, // ios终端
    iphone5:
      !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/) && screen.height === 568, // ios终端
  };

  return versions[type];
}

export function isDev() {
  return window.location.host.includes("-test");
}

export function isWeixin() {
  if (!isBrowser()) return;
  let ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") > -1;
}

export function parseQueryInUrl(string) {
  let res = {};
  string = string.substr(1);
  if (!string) return res;
  string.split("&").forEach((item) => {
    const regxp = /^(\S*)=(\S*)$/gi;
    regxp.test(item);
    res[RegExp.$1] = RegExp.$2;
  });
  return res;
}

export function formatSpeed(speed) {
  if (speed >= 0 && speed < 10) return speed.toFixed(2);
  if (speed >= 10 && speed < 100) return speed.toFixed(1);
  if (speed >= 100) return speed.toFixed(0);
  return speed;
}

export function throttle(fn, wait = 1500) {
  let prev = 0;
  return function (...args) {
    let now = +new Date();
    if (now - prev >= wait) {
      prev = now;
      return fn.apply(this, args);
    }
  };
}
